export const MAX_COMMENT_LENGTH = 255;
export const COMMENT_MAX_LENGTH_MESSAGE = `Comment must be ${MAX_COMMENT_LENGTH} characters or fewer`;
